import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

const About = () => {
  const services = [
    {
      title: "Private Healing Massages",
      description:
        "Our signature service focused on pain relief, tension release, and body restoration",
      icon: "✦",
    },
    {
      title: "Advanced Customized Facials",
      description:
        "Personalized skincare treatments designed to address your unique needs",
      icon: "✦",
    },
    {
      title: "Wood Therapy",
      description:
        "Therapeutic body sculpting and contouring techniques using specialized wooden tools",
      icon: "✦",
    },
    {
      title: "Body Exfoliation & Sauna Therapy",
      description:
        "Detoxifying treatments that rejuvenate skin and promote deep relaxation",
      icon: "✦",
    },
    {
      title: "Waxing Services",
      description:
        "Professional hair removal with attention to comfort and precision",
      icon: "✦",
    },
    {
      title: "Luxury Pedicures",
      description:
        "Indulgent foot care treatments for ultimate pampering and restoration",
      icon: "✦",
    },
  ];

  const values = [
    { title: "Luxury", icon: "◆" },
    { title: "Precision", icon: "◆" },
    { title: "Expertise", icon: "◆" },
    { title: "Confidence", icon: "◆" },
    { title: "Wellness", icon: "◆" },
  ];

  const features = [
    {
      title: "Expert-Led Treatments",
      description: "Performed by certified professionals",
    },
    {
      title: "Cutting-Edge Technology",
      description: "The latest innovations in beauty",
    },
    {
      title: "Tailored Beauty Plans",
      description: "Personalized for every client",
    },
    {
      title: "Luxury Meets Science",
      description: "A med spa experience like no other",
    },
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="hero-wrapper">
          <span className="hero-label">Discover Our Story</span>
          <h1>About Beautified By Linda</h1>
          <div className="hero-divider"></div>
          <p className="hero-description">
            Where luxury wellness meets personalized care
          </p>
        </div>
      </section>

      <section className="our-story-section">
        <div className="section-container">
          <div className="story-content">
            <div className="story-text">
              <span className="section-tag">Our Journey</span>
              <h2>Welcome to Our Sanctuary</h2>
              <p>
                <strong>Beautified by Linda Med Spa & Aesthetic</strong> is an{" "}
                <strong>
                  international luxury healing and aesthetic brand
                </strong>{" "}
                rooted in intentional care, restoration, and elevated wellness
                experiences.
              </p>
              <p>
                Our journey began with <strong>healing massage therapy</strong>{" "}
                — a service that quickly became our signature due to its deep
                focus on{" "}
                <strong>
                  pain relief, tension release, and body restoration
                </strong>
                . As our clients' needs evolved, so did our offerings. Today, we
                provide a carefully curated range of{" "}
                <strong>luxury, customized treatments</strong> designed to
                support both physical healing and overall well-being.
              </p>
              <p>
                Our services include{" "}
                <strong>
                  private healing massages, advanced customized facials, wood
                  therapy, waxing, body exfoliation treatments, sauna therapy
                </strong>
                , and <strong>luxury pedicures</strong>. Each experience is
                thoughtfully tailored to the individual, ensuring care that is
                never generic, rushed, or one-size-fits-all.
              </p>
              <p>
                We offer these services as{" "}
                <strong>exclusive home experiences</strong> as well as within
                our <strong>private studio</strong>, allowing clients to receive
                high-level care in the environment that best suits their
                lifestyle. Whether in your home or our space, privacy, comfort,
                and intention remain at the core of every session.
              </p>
              <p>
                Healing with Beautified by Linda extends beyond treatments.
                Through our growing <strong>e-commerce store</strong>, we offer
                a curated selection of wellness and beauty products, including{" "}
                <strong>
                  luxury handcrafted candles, diffusers, room sprays, skincare,
                  and lifestyle essentials
                </strong>
                . Each product is designed to help you maintain a calming,
                restorative environment long after your session ends.
              </p>
              <p>
                At <strong>Beautified by Linda Med Spa & Aesthetic</strong>, we
                believe true luxury lies in{" "}
                <strong>customization, care, and conscious healing</strong> —
                treating the body with intention while transforming the space
                you live in.
              </p>
            </div>
            <div className="story-visual">
              <div className="story-image-placeholder"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="section-container">
          <span className="section-tag">Our Foundation</span>
          <h2>Mission & Values</h2>
          <div className="values-container">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <span className="value-icon">{value.icon}</span>
                <h3>{value.title}</h3>
              </div>
            ))}
          </div>
          <p className="values-statement">
            We combine luxury with medical precision, offering non-invasive and
            minimally invasive treatments that enhance, rejuvenate, and sculpt.
            Our goal is to provide transformative results in a serene, high-end
            environment where every detail is crafted for your comfort and
            satisfaction.
          </p>
        </div>
      </section>

      <section className="founder-section">
        <div className="section-container">
          <div className="founder-layout">
            <div className="founder-visual">
              <div className="founder-image-placeholder"></div>
            </div>
            <div className="founder-content">
              <span className="section-tag">The Visionary</span>
              <h2>Meet Linda</h2>
              <p className="founder-bio">
                Linda, the visionary behind Beautified By Linda, is passionate
                about helping clients look and feel their best. With extensive
                expertise in aesthetics and medical-grade skincare, she is
                dedicated to delivering personalized, natural-looking results
                that enhance your unique beauty.
              </p>
              <div className="founder-quote">
                <span className="quote-mark">"</span>
                <p>Every treatment is an experience in luxury and precision.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="signature-services-section">
        <div className="section-container">
          <span className="section-tag">What We Offer</span>
          <h2>Our Signature Services</h2>
          <div className="services-showcase">
            {services.map((service, index) => (
              <div key={index} className="service-showcase-card">
                <span className="service-showcase-icon">{service.icon}</span>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose-section">
        <div className="section-container">
          <span className="section-tag">Our Commitment</span>
          <h2>Why Choose Us</h2>
          <div className="features-showcase">
            {features.map((feature, index) => (
              <div key={index} className="feature-showcase-card">
                <div className="feature-number">0{index + 1}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-wrapper">
          <h2>Ready to Begin Your Journey?</h2>
          <p>
            Indulge in the ultimate wellness experience. Book your consultation
            today and discover the art of personalized beauty.
          </p>
          <Link to="/bookings" className="cta-btn">
            Book Your Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
